import { useMutation, useQuery } from "@tanstack/react-query";
import { StudyFormValues } from "modules/Study/Study/helpers/study.types";
import { aliquotApiService } from "./aliquotemodule.api";

export const useAliquotQuery = (
  searchText?: string | null,
  pageNumber: number = 1,
  pageSize: number = 10,
) => {
  const SelectAllQuery = useQuery({
    queryKey: ["study-selectAll", , searchText, pageNumber, pageSize],
    queryFn: () =>
      aliquotApiService.getSelectAllData(searchText, pageNumber, pageSize),
  });

  const InsertMutation = useMutation<any, Error, StudyFormValues>({
    mutationFn: (payload: any) =>
      aliquotApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<any, Error, StudyFormValues>({
    mutationFn: (payload: StudyFormValues) =>
      aliquotApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<
    any,
    Error,
    { aliquotid: number; updatereason: string }
  >({
    mutationFn: (payload) =>
      aliquotApiService.deleteData({
        aliquotid: payload.aliquotid,
        updatereason: payload.updatereason,
      }),
  });

  return {
    SelectAllQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};
